//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/**
 * Detects genuine Google Chrome, excluding Chromium-based browsers that also
 * match the naive `Chrome/` user-agent token (Edge, Opera, Brave, Samsung
 * Internet, Vivaldi) and Chrome for iOS (CriOS runs on WebKit, not Blink, and
 * does not implement the Web Speech API).
 */
export const isChromeBrowser = (
  userAgent: string = typeof navigator !== 'undefined'
    ? navigator.userAgent
    : '',
): boolean => {
  const isChromium = /Chrome\//.test(userAgent);
  const isEdge = /Edg(e|A|iOS)?\//.test(userAgent);
  const isOpera = /(OPR|Opera)\//.test(userAgent);
  const isSamsungBrowser = /SamsungBrowser\//.test(userAgent);
  const isVivaldi = /Vivaldi\//.test(userAgent);
  const isBrave =
    typeof navigator !== 'undefined' && !!(navigator as any).brave;

  return (
    isChromium &&
    !isEdge &&
    !isOpera &&
    !isSamsungBrowser &&
    !isVivaldi &&
    !isBrave
  );
};
